<template>
  <div
    class="aside-layer"
    :expand="!collapse && asideCollapse"
    @mouseover="asideOver"
    @mouseleave="asideLeave"
  >
    <menuSide :collapse="collapse" />
  </div>
</template>
<script>
import menuSide from './index'
import { mapState, mapActions } from 'vuex'
export default {
  components: { menuSide },
  data () {
    return {
      collapse: true
    }
  },
  computed: {
    ...mapState('admin/menu', ['asideCollapse'])
  },
  watch: {
    asideCollapse: {
      handler (val) {
        this.collapse = val
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('admin/menu', ['asideCollapseSet']),
    asideOver () {
      if (!this.asideCollapse) return
      this.collapse = false
    },
    asideLeave () {
      if (!this.asideCollapse) return
      this.collapse = true
    }
  }
}
</script>
